import { c as _c } from "react/compiler-runtime";
import { useNumberFormatter } from "@opensea/i18n";
import { FlexCenter, TextBody, Toast, ToastAvatar, ToastContent, ToastDescription, ToastErrorIcon, ToastSide, ToastSuccessIcon, ToastTitle } from "@opensea/ui-kit";
import { StacksFilled, TraitOffer } from "@opensea/ui-kit/icons";
import { useTranslations } from "use-intl";
import { Avatar } from "../../../components/Avatar";
import { useRenderImage } from "../../../providers/RenderImageProvider";
export function CreateCollectionOfferToast(t0) {
  const $ = _c(32);
  const {
    imageUrl,
    price,
    trait,
    traits,
    status
  } = t0;
  const t = useTranslations("wallet.CreateCollectionOfferToast");
  const {
    renderImage
  } = useRenderImage();
  const format = useNumberFormatter();
  const hasTraits = Boolean(trait || traits?.length);
  let t1;
  if ($[0] !== hasTraits) {
    t1 = <Avatar.Badge>{hasTraits ? <TraitOffer size={12} /> : <StacksFilled size={12} />}</Avatar.Badge>;
    $[0] = hasTraits;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = imageUrl || "";
  let t3;
  if ($[2] !== renderImage || $[3] !== t1 || $[4] !== t2) {
    t3 = <ToastAvatar badge={t1} renderImage={renderImage} src={t2} />;
    $[2] = renderImage;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== format || $[7] !== hasTraits || $[8] !== price || $[9] !== status || $[10] !== t || $[11] !== trait || $[12] !== traits?.length) {
    t4 = status === "SUCCESS" && <><ToastTitle><FlexCenter className="gap-1 text-nowrap">{hasTraits ? t("traitOfferSuccessTitle") : t("collectionOfferSuccessTitle")}{" "}{hasTraits ? <TextBody color="text-secondary" weight="regular">{trait ? `${trait.traitType}: ${trait.value}` : t("traits", {
              count: traits?.length ?? 0
            })}</TextBody> : null}</FlexCenter></ToastTitle><ToastDescription>{format(price.unit, {
          display: "full",
          suffix: price.symbol
        })}</ToastDescription></>;
    $[6] = format;
    $[7] = hasTraits;
    $[8] = price;
    $[9] = status;
    $[10] = t;
    $[11] = trait;
    $[12] = traits?.length;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== hasTraits || $[15] !== status || $[16] !== t) {
    t5 = status === "FAILED" && <ToastTitle>{hasTraits ? t("traitOfferFailedTitle") : t("collectionOfferFailedTitle")}</ToastTitle>;
    $[14] = hasTraits;
    $[15] = status;
    $[16] = t;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t4 || $[19] !== t5) {
    t6 = <ToastContent>{t4}{t5}</ToastContent>;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== status) {
    t7 = status === "SUCCESS" && <ToastSuccessIcon />;
    $[21] = status;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== status) {
    t8 = status === "FAILED" && <ToastErrorIcon />;
    $[23] = status;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== t7 || $[26] !== t8) {
    t9 = <ToastSide>{t7}{t8}</ToastSide>;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== t3 || $[29] !== t6 || $[30] !== t9) {
    t10 = <Toast>{t3}{t6}{t9}</Toast>;
    $[28] = t3;
    $[29] = t6;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  return t10;
}